import { useCallback, useEffect } from 'react';
import { useReportBuilderContext } from '../../../report-builder.context';
import { useOnboardingContext } from '../../../onboarding.context';
import {
  HELP_MENU_EVENTS,
  useHelpMenuContext
} from '../../../../../../skeleton/src/help/HelpMenuContext/HelpMenuContext';
import { APP_WIDGET_NAMES, CARD_TYPES, ONBOARDING_STEPS, WIDGET_TYPES } from '../../../types';

export const OnboardingProgressDetection = () => {
  const { currentStep, setIsNextEnabled, handleNext } = useOnboardingContext();
  const { currentCard, pageLayoutData, setScrollReportTo } = useReportBuilderContext();
  const { openMenu } = useHelpMenuContext();

  const handleCloseHelpMenu = useCallback(() => {
    handleNext();
  }, [handleNext]);

  // Enable the 'next' button if appropriate
  useEffect(() => {
    switch (currentStep) {
      case ONBOARDING_STEPS.ADD_TEMPLATE: {
        if (
          pageLayoutData.find(
            item => item.type === CARD_TYPES.WIDGET && item.widget?.widgetType === WIDGET_TYPES.DATA_CARD
          )
        ) {
          setIsNextEnabled(true);
        } else {
          setIsNextEnabled(false);
        }
        break;
      }

      case ONBOARDING_STEPS.ADD_WIDGET: {
        if (
          pageLayoutData.find(
            item =>
              item.type === CARD_TYPES.APP_WIDGET &&
              item.app_widget?.name &&
              item.app_widget.name === APP_WIDGET_NAMES.CUSTOMERS_PAID_MOST
          )
        ) {
          setIsNextEnabled(true);
        } else {
          setIsNextEnabled(false);
        }
        break;
      }

      case ONBOARDING_STEPS.SELECT_WIDGET: {
        setScrollReportTo([0, 0]);
        setIsNextEnabled(!!currentCard);
        break;
      }

      case ONBOARDING_STEPS.ADD_TEXT_IMAGES:
      case ONBOARDING_STEPS.SEND_OR_SCHEDULE: {
        setIsNextEnabled(true);
        break;
      }

      case ONBOARDING_STEPS.SEE_HELP: {
        openMenu();
        setIsNextEnabled(true);
        break;
      }

      default: {
        setIsNextEnabled(false);
      }
    }
  }, [
    currentCard,
    currentStep,
    openMenu,
    pageLayoutData,
    setIsNextEnabled,
    setScrollReportTo
  ]);

  // On help step, listen for help menu close and advance
  useEffect(() => {
    if (currentStep === ONBOARDING_STEPS.SEE_HELP) {
      window.addEventListener(HELP_MENU_EVENTS.close, handleCloseHelpMenu);
      return () => {
        window.removeEventListener(HELP_MENU_EVENTS.close, handleCloseHelpMenu);
      };
    }
  }, [currentStep, handleCloseHelpMenu]);

  return null;
};
